import { useContext, useState } from "react"
import { Button, IconGoogle } from "../../../../components/atoms"
import {
  FlatpickerHourGroup,
  InputGroup,
  SelectGroup
} from "../../../../components/molecules"
import { AuthContext } from "../../../../contexts/Auth/AuthContext"
import { NotificationContext } from "../../../../contexts/NotificationCTX/NotificationContext"
import { api } from "../../../../helpers"

export function FormTour() {
  const {
    setType,
    setShow,
    setText: setTextAlert
  } = useContext(NotificationContext)

  const { applicationData } = useContext(AuthContext)
  const [campoObrigatorioDataInicial, setcampoObrigatorioDataInicial] =
    useState<boolean>(false)
  const [campoObrigatorioDataFinal, setcampoObrigatorioDataFinal] =
    useState<boolean>(false)
  const [campoObrigatorioLotacao, setcampoObrigatorioLotacao] =
    useState<boolean>(false)
  const [campoObrigatorioFilial, setcampoObrigatorioFilial] =
    useState<boolean>(false)
  const [campoObrigatorioRota, setcampoObrigatorioRota] =
    useState<boolean>(false)
  const [campoObrigatorioCrianca, setcampoObrigatorioCrianca] =
    useState<boolean>(false)
  const [campoObrigatorioPreco, setcampoObrigatorioPreco] =
    useState<boolean>(false)
  const [campoObrigatorioBarco, setcampoObrigatorioBarco] =
    useState<boolean>(false)
  const [campoObrigatorioOrigem, setcampoObrigatorioOrigem] =
    useState<boolean>(false)
  const [campoObrigatorioDestino, setcampoObrigatorioDestino] =
    useState<boolean>(false)
  const [campoObrigatorioDuracao, setcampoObrigatorioDuracao] =
    useState<boolean>(false)
  const [dataInicial, setDataInicial] = useState<Date | string>("")
  const [dataFinal, setDataFinal] = useState<Date | string>("")
  const [preco, setPreco] = useState("0.00")
  const [filial, setFilial] = useState("0")
  const [lotacao, setLotacao] = useState("")
  const [crianca, setCrianca] = useState("0")
  const [bagagem, setBagagem] = useState("0")
  const [recolhido, setRecolhido] = useState("0")
  const [liberado, setLiberado] = useState("0")
  const [origem, setOrigem] = useState("0")
  const [destino, setDestino] = useState("0")
  const [duracao, setDuracao] = useState("3")
  const [barco, setBarco] = useState("0")
  const [rota, setRota] = useState("NORMAL")

  const gravar = async () => {
    let useradd = applicationData.funcionario
    const response = await api.post("/api/passeios/incluirlote", {
      vempresa: filial,
      vdataInicial: dataInicial,
      vdataFinal: dataFinal,
      vpreco: preco,
      vlotacao: lotacao,
      vcrianca: crianca,
      vbagagem: bagagem,
      vrecolhido: recolhido,
      vliberado: liberado,
      vorigem: origem,
      vdestino: destino,
      vduracao: duracao,
      vbarco: barco,
      vrota: rota,
      useradd
    })
    if (response.status === 200) {
      setType("success")
      setTextAlert(response.statusText)
      setShow(true)
    }
  }

  return (
    <div>
      <h2>Incluir Passeio</h2>
      <div className="row mt-1">
        <div className="col-sm-12 col-lg-3">
          <FlatpickerHourGroup
            label="Data/Hora Inicial"
            messageError={
              campoObrigatorioDataInicial ? "Campo obrigatório!" : ""
            }
            value={dataInicial}
            id="data-ini"
            onChange={([date]) => {
              if (String(date) !== "undefined") {
                setDataInicial(date)
                setcampoObrigatorioDataInicial(false)
              } else {
                setcampoObrigatorioDataInicial(true)
              }
            }}
          />
        </div>
        <div className="col-sm-12 col-lg-3">
          <FlatpickerHourGroup
            label="Data/Hora Final"
            messageError={campoObrigatorioDataFinal ? "Campo obrigatório!" : ""}
            value={dataFinal}
            id="data-fim"
            onChange={([date]) => {
              if (String(date) !== "undefined") {
                setDataFinal(date)
                setcampoObrigatorioDataFinal(false)
              } else {
                setcampoObrigatorioDataFinal(true)
              }
            }}
          />
        </div>
        <div className="col-sm-12 col-lg-3">
          <InputGroup
            className="col-sm-12 col-lg-2"
            label="Preço"
            messageError={campoObrigatorioPreco ? "Campo obrigatório!" : ""}
            id="preco"
            type="number"
            value={preco}
            autoComplete="off"
            onChange={(e) => {
              if (
                Number(e.target.value) <= 1000 &&
                Number(e.target.value) >= 0
              ) {
                setPreco(e.target.value)
                setcampoObrigatorioPreco(false)
              }
              if (e.target.value === "") setcampoObrigatorioPreco(true)
            }}
          />
        </div>
        <div className="col-sm-12 col-lg-3">
          <SelectGroup
            value={filial}
            id="filial"
            messageError={campoObrigatorioFilial ? "Campo obrigatório!" : ""}
            label="Filial"
            options={applicationData.filiais.map((filial: Filial) => ({
              text: filial.nome,
              value: filial.codigo
            }))}
            onChange={(e) => {
              if (Number(e.target.value) <= 10 && Number(e.target.value) >= 0) {
                setFilial(e.target.value)
                setcampoObrigatorioFilial(false)
              }
              if (e.target.value === "") setcampoObrigatorioFilial(true)
            }}
          />
        </div>
      </div>

      <div className="row mt-1">
        <div className="col-sm-12 col-lg-2">
          <InputGroup
            className="col-sm-12 col-lg-2"
            label="Lotação"
            messageError={campoObrigatorioLotacao ? "Campo obrigatório!" : ""}
            id="lotacao"
            type="number"
            value={lotacao}
            autoComplete="off"
            onChange={(e) => {
              if (
                Number(e.target.value) <= 500 &&
                Number(e.target.value) >= 0
              ) {
                setLotacao(e.target.value)
                setcampoObrigatorioLotacao(false)
              }
              if (e.target.value === "") setcampoObrigatorioLotacao(true)
            }}
          />
        </div>
        <div className="col-sm-12 col-lg-2">
          <InputGroup
            className="col-sm-12 col-lg-2"
            label="Criança"
            messageError={campoObrigatorioCrianca ? "Campo obrigatório!" : ""}
            id="crianca"
            type="number"
            value={crianca}
            autoComplete="off"
            onChange={(e) => {
              if (Number(e.target.value) <= 40 && Number(e.target.value) >= 0) {
                setCrianca(e.target.value)
                setcampoObrigatorioCrianca(false)
              }
              if (e.target.value === "") setcampoObrigatorioCrianca(true)
            }}
          />
        </div>
        <div className="col-sm-12 col-lg-2">
          <InputGroup
            className="col-sm-12 col-lg-2"
            label="Duração"
            messageError={campoObrigatorioDuracao ? "Campo obrigatório!" : ""}
            id="duracao"
            type="number"
            value={duracao}
            autoComplete="off"
            onChange={(e) => {
              if (Number(e.target.value) <= 5 && Number(e.target.value) >= 0) {
                setDuracao(e.target.value)
                setcampoObrigatorioDuracao(false)
              }
              if (e.target.value === "") setcampoObrigatorioDuracao(true)
            }}
          />
        </div>
      </div>

      <div className="row mt-1">
        <div className="col-sm-12 col-lg-3">
          <SelectGroup
            value={origem}
            messageError={campoObrigatorioOrigem ? "Campo obrigatório!" : ""}
            id="origem"
            label="Origem"
            options={applicationData.destinos.map((destino: Destino) => ({
              text: destino.nome,
              value: destino.codigo
            }))}
            onChange={(e) => {
              if (Number(e.target.value) <= 20 && Number(e.target.value) >= 0) {
                setOrigem(e.target.value)
                setcampoObrigatorioOrigem(false)
              }
              if (e.target.value === "") setcampoObrigatorioOrigem(true)
            }}
          />
        </div>
        <div className="col-sm-12 col-lg-3">
          <SelectGroup
            value={destino}
            messageError={campoObrigatorioDestino ? "Campo obrigatório!" : ""}
            id="destino"
            label="Destino"
            options={applicationData.destinos.map((destino: Destino) => ({
              text: destino.nome,
              value: destino.codigo
            }))}
            onChange={(e) => {
              if (Number(e.target.value) <= 20 && Number(e.target.value) >= 0) {
                setDestino(e.target.value)
                setcampoObrigatorioDestino(false)
              }
              if (e.target.value === "") setcampoObrigatorioDestino(true)
            }}
          />
        </div>
        <div className="col-sm-12 col-lg-3">
          <SelectGroup
            value={barco}
            messageError={campoObrigatorioBarco ? "Campo obrigatório!" : ""}
            id="barco"
            label="Barco"
            options={applicationData.barcos.map((barco: Barco) => ({
              text: barco.nome,
              value: barco.codigo
            }))}
            onChange={(e) => {
              if (Number(e.target.value) <= 20 && Number(e.target.value) >= 0) {
                setBarco(e.target.value)
                setcampoObrigatorioBarco(false)
              }
              if (e.target.value === "") setcampoObrigatorioBarco(true)
            }}
          />
        </div>
        <div className="col-sm-12 col-lg-3">
          <SelectGroup
            value={rota}
            messageError={campoObrigatorioRota ? "Campo obrigatório!" : ""}
            id="rota"
            label="Rota"
            options={[
              { text: "CONEXÃO", value: "CONEXÃO" },
              { text: "NORMAL", value: "NORMAL" }
            ]}
            onChange={(e) => {
              if (Number(e.target.value) <= 10 && Number(e.target.value) >= 0) {
                setRota(e.target.value)
                setcampoObrigatorioRota(false)
              }
              if (e.target.value === "") setcampoObrigatorioRota(true)
            }}
          />
        </div>
      </div>

      <div className="row mt-3"></div>
      <div className="row mt-1">
        <div className="col-sm-12 col-lg-2">
          <Button
            appearance="success"
            onClick={() => {
              gravar()
            }}
          >
            Gravar<IconGoogle>save</IconGoogle>
          </Button>
        </div>
      </div>
    </div>
  )
}
